import React from 'react';
import { Helmet } from 'react-helmet-async';

const Ktpn160Page = () => {
  const handleAccordion = (e: React.MouseEvent<HTMLDivElement>) => {
    const header = e.currentTarget;
    const content = header.nextElementSibling as HTMLElement;
    const icon = header.querySelector('i');
    if (content && icon) {
      content.classList.toggle('active');
      icon.style.transform = content.classList.contains('active')
        ? 'rotate(180deg)'
        : 'rotate(0deg)';
    }
  };

  return (
    <>
      <Helmet>
        <title>КТПН 160 кВА — подстанция для среднего бизнеса, ТЦ, ЖК</title>
      </Helmet>
      <main>
        <section className="bg-[#f9fcff] py-16">
          <div className="container mx-auto px-7">
            <div className="flex flex-wrap gap-12 items-center">
              <div className="flex-1">
                <h1 className="text-5xl font-semibold text-[#1a3a4f]">
                  КТПН 160 кВА — надёжное энергоснабжение для ЖК, ТЦ, среднего бизнеса
                </h1>
                <p className="text-lg text-[#2c5a7a] mt-5">
                  Комплектная трансформаторная подстанция наружной установки мощностью 160 кВА.
                  Идеально подходит для многоквартирных домов, торговых центров, школ.
                </p>
                <div className="flex flex-wrap gap-4 my-6">
                  <span className="bg-white text-sm font-medium px-4 py-2 rounded-full border border-gray-200 shadow-sm">
                    <i className="fas fa-check-circle"></i> Заводская готовность
                  </span>
                  <span className="bg-white text-sm font-medium px-4 py-2 rounded-full border border-gray-200 shadow-sm">
                    <i className="fas fa-shield-alt"></i> Корпус IP23/IP54
                  </span>
                  <span className="bg-white text-sm font-medium px-4 py-2 rounded-full border border-gray-200 shadow-sm">
                    <i className="fas fa-file-certificate"></i> ГОСТ / ТР ТС
                  </span>
                </div>
                <div className="flex flex-wrap gap-4 mt-8">
                  <a
                    href="#requestForm"
                    className="inline-flex items-center gap-2 px-6 py-3 rounded-full font-semibold text-white bg-[#1e4a6e] hover:bg-[#0f3550]"
                  >
                    <i className="fas fa-file-invoice"></i> Запросить коммерческое предложение
                  </a>
                  <a
                    href="#"
                    className="inline-flex items-center gap-2 px-6 py-3 rounded-full font-semibold text-[#1e4a6e] bg-[#f0f4f8] hover:bg-[#e6edf4] border border-[#cbdde9]"
                  >
                    <i className="fas fa-download"></i> Скачать опросный лист
                  </a>
                </div>
              </div>
              <div className="flex-none w-full md:w-2/5">
                <img
                  src="https://images.pexels.com/photos/7876133/pexels-photo-7876133.jpeg?auto=compress&cs=tinysrgb&w=800"
                  alt="КТПН 160 кВА"
                  className="rounded-2xl shadow-lg"
                />
              </div>
            </div>
          </div>
        </section>
        {/* Other sections will be added here */}
      </main>
    </>
  );
};

export default Ktpn160Page;
